import * as Selectors  from './selectors';
import { useSelector } from 'react-redux';


// Template Hooks

// Selectors

export function useTemplates(businessID) {
  return useSelector(state => Selectors.getTemplates(state, businessID));
}

export function useTemplatesStatuses(businessID) {
  return useSelector(state => Selectors.getTemplatesStatuses(state, businessID));
}

export function useTemplate(templateID) {
  return useSelector(state => Selectors.getTemplate(state, templateID));
}
